import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isString, noop } from 'lodash';
import classnames from 'classnames';

import { Button } from 'components/core/Button';
import { DatePicker } from 'components/core/DatePicker';
import { GoogleAutocomplete } from 'components/core/GoogleAutocomplete';
import { Paragraph } from 'components/core/Typography';
import { ClickToShowNumberButton } from 'components/contact/ClickToShowNumberButton';
import { Search } from 'components/svg';
import './searchBox.scss';
import { trackCTAClick } from '../../core/library/tracking-utils/tracking/clickTrackingUtils';
import { compose } from 'recompose';
import { connect } from 'react-redux';

// TODO: Recompose

const mapStateToProps = (state) => ({
	geolocation: state.user.geolocation || {},
});

export const enhance = compose(connect(mapStateToProps));
export class SearchBox extends PureComponent {
	static propTypes = {
		handleSearch: PropTypes.func,
		datePickerLabel: PropTypes.string,
		inputLabel: PropTypes.string,
		reservationWindow: PropTypes.instanceOf(Date),
		moveInDate: PropTypes.instanceOf(Date),
		location: PropTypes.string,
		withDatePicker: PropTypes.bool,
		darkButton: PropTypes.bool,
		pinkButton: PropTypes.bool,
		slpPinkButton: PropTypes.bool,
		buttonText: PropTypes.node,
		buttonIcon: PropTypes.bool,
		id: PropTypes.string,
		hideOnScroll: PropTypes.bool, // sf_11267_sticky_search_clp_hero
		// sf_12700_sfdc_paid_landing_refresh
		clickToCall: PropTypes.bool,
		getTollfreePhoneNumber: PropTypes.func,
		parentPhoneNumber: PropTypes.object,
		setParentPhoneNumber: PropTypes.func,
		parentPhoneLoaded: PropTypes.func,
		setParentPhoneLoaded: PropTypes.func,
		className: PropTypes.string,
		geolocation: PropTypes.shape({
			city: PropTypes.string,
			region: PropTypes.string,
		}),
	};

	static defaultProps = {
		handleSearch: noop,
		datePickerLabel: 'Check in',
		location: '',
		buttonText: 'Search',
		inputLabel: 'Enter address, city or zip',
		hideOnScroll: false, // sf_11267_sticky_search_clp_hero
		clickToCall: false, // sf_12700_sfdc_paid_landing_refresh
		className: '',
	};

	constructor(props) {
		super(props);
		let defaultLocation = '';
		if (props?.geolocation?.city || props?.geolocation?.region) {
			defaultLocation = `${props.geolocation.city || ''}, ${props.geolocation.region || ''}`;
		}
		this._setRef = this._setRef.bind(this);
		this.state = {
			locationParams: { location: props.location || defaultLocation },
			date: props.moveInDate,
			userHasInteracted: false, // Track if user has manually changed the input
		};
	}

	componentDidUpdate(prevProps) {
		// Only update internal state if:
		// 1. The location prop has changed from parent
		// 2. AND the user hasn't manually interacted with the input
		// 3. AND it's actually different from current state
		if (
			prevProps.location !== this.props.location &&
			!this.state.userHasInteracted &&
			this.props.location !== this.state.locationParams.location
		) {
			this.setState({
				locationParams: { location: this.props.location },
			});
		}
	}

	_handleDateChange = (evt) => {
		const { value } = evt.target;

		this.setState({ date: value.date });
	};

	_handleGoogle = (locationParams) => {
		// Mark that user has interacted with the input
		// This prevents parent prop updates from overwriting user's selection
		this.setState({
			locationParams,
			userHasInteracted: true,
		});
	};

	_handleSearch = (event) => {
		event.preventDefault();

		let searchParams;
		const { locationParams, date } = this.state;

		if (locationParams.locationSource) {
			searchParams = locationParams;
		} else if (this.instance) {
			searchParams = { location: this.instance.value };
		} else {
			searchParams = locationParams;
		}

		const searchInputId = this.props.id || this.props.inputLabel;

		/* istanbul ignore else */
		if (isString(searchParams.location) && searchParams.location.length) {
			trackCTAClick(
				searchInputId || 'search-box-id',
				'Search Button',
				this.props?.buttonText?.props?.children ||
					this.props?.buttonText ||
					'Search',
			);

			this.props.handleSearch({
				locationParams: searchParams,
				date,
				searchInputId,
			});
		}
	};

	_setRef = (ref) => {
		this.instance = ref;
	};

	render() {
		const ButtonIcon = this.props.buttonIcon;
		return (
			<div className={`search-box-container ${this.props.className}`}>
				{' '}
				{/* sf_12700_sfdc_paid_landing_refresh */}
				<form
					className={classnames('search-box', {
						'with-date': this.props.withDatePicker,
					})}
					onSubmit={this._handleSearch}
				>
					<GoogleAutocomplete
						label={this.props.inputLabel}
						// Adding an automatically generated ID to avoid a an iOS autofocus bug that happens
						// when there is more than one input field with the same ID on a page
						id={
							this.props.id ||
							`location-${Math.floor(
								Math.random() * Math.floor(1000),
							)}`
						}
						className="location"
						name="location"
						onChange={this._handleGoogle}
						getRef={this._setRef}
						value={this.state.locationParams.location}
						hideOnScroll={this.props.hideOnScroll} // sf_11267_sticky_search_clp_hero
					/>
					<div className="date-search-wrapper">
						{!!this.props.withDatePicker && (
							<DatePicker
								label={this.props.datePickerLabel}
								id="date"
								className="date"
								name="date"
								value=""
								reservationWindow={this.props.reservationWindow}
								selectedDate={this.state.date}
								onChange={this._handleDateChange}
							/>
						)}
						<Button
							className="search-button"
							pink={this.props.pinkButton}
							dark={this.props.darkButton}
							slpPink={this.props.slpPinkButton}
							type="submit"
						>
							{!!ButtonIcon && <Search />}
							{this.props.buttonText}
						</Button>
					</div>
				</form>
				{this.props.clickToCall && ( // sf_12700_sfdc_paid_landing_refresh
					<div className="call-container">
						<Paragraph
							last
							color="black"
							weight="ultraBold"
						>
							OR
						</Paragraph>
						<ClickToShowNumberButton
							outline
							fetchPhoneNumber={this.props.getTollfreePhoneNumber}
							showAsLink
							size="small"
							label="Call to Find Storage"
							// sf_12700_sfdc_paid_landing_refresh
							parentPhoneNumber={this.props.parentPhoneNumber}
							setParentPhoneNumber={
								this.props.setParentPhoneNumber
							}
							parentPhoneLoaded={this.props.parentPhoneLoaded}
							setParentPhoneLoaded={
								this.props.setParentPhoneLoaded
							}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default enhance(SearchBox);
